<template>
  <AppSection class="wrapper">
    <AppContainer>
      <AppThirdLayout>
        <figure>
          <AppImg :src="img.src" :alt="$t(img.alt!)" />
        </figure>
        <div class="content">
          <h2>
            {{ $tt(`page.visa_starting_price_${country}`, { price }) }}
          </h2>
          <p v-html="$tt(`page.start_filling_form_${country}`, { price })" class="mt-5 mb-7" />
          <AppBtn class="px-7" size="x-large" primary @click="ctaClickBus.emit">
            {{ $tt(`page.get_visa_cta_${country}`) }}
            <ChevronMarker dir="next" class="ms-2" />
          </AppBtn>
        </div>
      </AppThirdLayout>
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { Price, Image } from '~/types';

const country = inject(countryKeyInjectionKey)!;

const props = defineProps<{
  price: Price;
  img: Image;
}>();

const { ctaClickBus } = useEmitter();
const { displayPrice } = useFormat();
const price = displayPrice(props.price);
</script>

<style scoped>
.content {
  padding-inline-end: 200px;
}
p {
  font-size: 24px;
}
@media (max-width: 850px) {
  .wrapper {
    padding-bottom: var(--space-9) !important;
  }
  figure {
    width: 80% !important;
    margin-inline: auto;
  }
  .content {
    padding-inline-end: 0;
    text-align: center;
  }
  p {
    font-size: 16px;
  }
  button {
    width: 100%;
  }
}
</style>